import { render, staticRenderFns } from "./PersonnelView.vue?vue&type=template&id=174179a8&scoped=true&"
import script from "./PersonnelView.vue?vue&type=script&lang=js&"
export * from "./PersonnelView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174179a8",
  null
  
)

export default component.exports